import { useState } from 'react';
import { NJIconButton, NJMenu } from '@engie-group/fluid-design-system-react';
import { UMR } from '../_components/referenceTokens';

export const SELECTION_ACTIONS: { label: string; message: string }[] = [
  { label: 'Éditer la sélection', message: 'Simulation — édition de la sélection non appliquée.' },
  { label: 'Dupliquer la sélection', message: 'Simulation — aucune copie de la sélection créée.' },
  { label: 'Partager la sélection', message: 'Simulation — aucun partage ni droit modifié.' },
  { label: 'Supprimer la sélection', message: 'Simulation — aucune sélection supprimée.' },
];

export function SelectionActions({ onMessage }: { onMessage: (message: string) => void }) {
  const [opened, setOpened] = useState(false);
  return <NJMenu.Root opened={opened} onOpen={setOpened}>
    <NJMenu.Anchor>
      <NJIconButton label="Actions de la sélection" aria-label="Actions de la sélection" title="Voir les actions"
        icon="more_vert" variant="tertiary" scale="sm" />
    </NJMenu.Anchor>
    <NJMenu.Dropdown aria-label="Actions de la sélection"
      style={{ minWidth: 220, maxWidth: 'calc(100vw - 24px)', fontFamily: UMR.font }}>
      {SELECTION_ACTIONS.map((action) => <NJMenu.Item key={action.label} label={action.label}
        role="menuitem" style={{ padding: '4px 16px', width: '100%', textAlign: 'left',
          fontFamily: UMR.font, fontSize: 14, lineHeight: '21px' }}
        onClick={() => { setOpened(false); onMessage(action.message); }}>
        {action.label}
      </NJMenu.Item>)}
    </NJMenu.Dropdown>
  </NJMenu.Root>;
}
